var exports = {
  "kL": "xaf9ae18d--6d5675--container",
  "_R": "xaf9ae18d--6d5675--close-button",
  "wx": "xaf9ae18d--6d5675--header",
  "BH": "xaf9ae18d--6d5675--tabs-wrapper",
  "o5": "xaf9ae18d--6d5675--content-wrapper",
  "W0": "xaf9ae18d--6d5675--data-from",
  "Zu": "xaf9ae18d--6d5675--fixed",
};

module.exports = exports;
